
import React from 'react'
import DocumentMeta from 'react-document-meta'
import LoggedOutHeader from './LoggedOutHeader'
import ResetError from './ResetError'
import ResetForm from './ResetForm'
import ResetFooter from './ResetFooter'
import ShowHide from 'ui/ShowHide'
import Space from 'ui/Space'
import css from './Reset.module.css'

const Reset = props => (
  <div className={css.main}>
    <DocumentMeta title='Reset - Segment' referrer='never' />

    <LoggedOutHeader title='Reset Your Password' />

    <ShowHide show={!props.token}>
      <ResetError missing />
    </ShowHide>

    <ShowHide show={props.token}>
      <ShowHide show={props.didError}>
        <ResetError invalid={props.errorStatus === 404} />
        <Space value='20' />
      </ShowHide>

      <ResetForm onSubmit={data => props.onSubmit({ ...data, token: props.token })} />
    </ShowHide>

    <ResetFooter />
  </div>
)

export default Reset



// WEBPACK FOOTER //
// ./components/Reset.js